import { canIShowTagAboveProductName } from '@/utils/common/product-card';
import useTranslation from 'next-translate/useTranslation';
import { ProductCardProps } from '../../types';
import { twMerge } from '@weee-fe/module';

const CardBodyTopTag: React.FC<Partial<ProductCardProps>> = props => {
  const { data, className, topTagClasses: classes } = props;
  const { t } = useTranslation('common');
  //展示判断和产品名称相关
  const show = canIShowTagAboveProductName(data);
  if (!show) return null;
  return (
    <div className={twMerge('mb-0.5', className)}>
      {data?.is_hotdish === 'Y' && (
        <div className={twMerge('text-link-base-1 text-[12px]', classes?.hotdishTag)}>{t('card_hotdish_tag')}</div>
      )}
      {/* {data?.category === 'bundle' && <div>{t('card_bundle_tag')}</div>} */}
      {!!data?.sponsored_text && (
        <div
          data-testid="wid-product-card-sponsored-text"
          className={twMerge('text-surface-100-fg-minor enki-body-2xs-medium line-clamp-1', classes?.sponsoredText)}>
          {data.sponsored_text}
        </div>
      )}
      {!data?.sponsored_text && !!data?.brand_name && (
        <div
          data-testid="wid-product-card-brand"
          className="text-surface-100-fg-minor enki-body-2xs-medium line-clamp-1">
          {data?.brand_name}
        </div>
      )}
    </div>
  );
};

export default CardBodyTopTag;
